export default __webpack_public_path__ + "static/media/73-730815_360918-naruto-shippuuden-159-mp4-snapshot-16-45-1720518452226.b811e653.png";